<template>
  <div>
    <v-btn
      small
      text
      :color="buttonColor"
      @click="handleGetReport"
      v-if="this.isIconButton"
    >
      <Loader
        v-if="isLoading"
        size="x-small"
        :color="this.loaderColor"
        text=""
        class="mr-2"
      ></Loader>
      <v-icon v-if="buttonLeftIcon && !isLoading" size="12" class="mr-2">{{
        buttonLeftIcon
      }}</v-icon
      >{{ this.reportType }}
      <span class="text-capitalize font-weight-bold">Report</span>
    </v-btn>

    <v-btn outlined small @click="handleGetReport" v-else-if="this.isButton">
      <Loader
        v-if="isLoading"
        size="small"
        :color="this.loaderColor"
        text=""
      ></Loader>
      {{ this.reportType }} (PDF)
    </v-btn>

    <v-list-item
      v-else
      :disabled="isLoading"
      @click="!isLoading && handleGetReport()"
    >
      <v-list-item-title
        >Generate {{ this.reportType }} (PDF)
        <Loader
          v-if="isLoading"
          text=""
          :color="this.loaderColor"
          size="small"
        ></Loader
      ></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "ReportButton",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    isIconButton: {
      type: Boolean,
      default: false,
    },
    buttonColor: {
      type: String,
      default: "",
    },
    isButton: {
      type: Boolean,
      default: true,
    },
    getReport: {
      type: Function,
      required: true,
    },
    reportType: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: false,
    },
    loaderColor: {
      type: String,
      default: "black",
    },
    buttonLeftIcon: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  async mounted() {},
  methods: {
    async handleGetReport() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.report,
        EVENT_ACTIONS.clicked,
        `${this.reportType}`
      );
      let requestTimestamp = new Date().toISOString();
      this.isLoading = true;
      await this.getReport(this.params, requestTimestamp);
      this.isLoading = false;
    },
  },
};
</script>

<style scoped></style>
